import { send } from '../../../../../../../src/network';
import { type CustomerPairingRatingDetail } from '../../../../../../../src/types/CustomerPairingRatingDetail';

export type Params = {
  pairing_id: number;
};

export async function getApiV2CustomersSelfPairingRatingsPairingId(
  params: Params
) {
  return await send<CustomerPairingRatingDetail>({
    path: `/api/v2/customers/self/pairing_ratings/${params.pairing_id}/`,
    method: 'GET',
  });
}
